export const ShuffleTraitRarities = {
  Common: 'Common',
  Uncommon: 'Uncommon',
  Rare: 'Rare',
  UltraRare: 'Ultra Rare',
};

export const shuffleTraitRarityPercentages = {
  [ShuffleTraitRarities.Common]: 70,
  [ShuffleTraitRarities.Uncommon]: 20,
  [ShuffleTraitRarities.Rare]: 8,
  [ShuffleTraitRarities.UltraRare]: 2,
};

export const shuffleTraitDependencies = {
  Clothing: {
    'Avocado Suit': {
      Head: 'None',
      Whiskers: 'Normal',
    },
    'Watermelon Suit': {
      Head: 'None',
    },
    'Gum-ball Machine Suit': {
      Head: 'None',
    },
    Snake: {
      Accessory: 'None',
    },
    'Baja Hoodie': {
      Head: 'None',
      Whiskers: 'Normal',
    },
  },
  Head: {
    'Shark Hat': {
      Eyes: 'Normal',
      Whiskers: 'Normal',
    },
    Cyborg: {
      Whiskers: 'Normal',
      Eyes: 'Normal',
    },
    Flower: {
      Whiskers: 'Normal',
    },
    'Fish Bowl - Normal': {
      Eyes: 'Normal',
      Whiskers: 'Normal',
    },
    'Fish Bowl - Skeleton': {
      Eyes: 'Normal',
      Whiskers: 'Normal',
    },
    TV: {
      Eyes: 'Normal',
      Whiskers: 'Normal',
    },
    'Trash Can Lid': {
      Eyes: 'Normal',
    },
    'Slime Eye': {
      Eyes: 'Normal',
      Whiskers: 'Normal',
    },
    'Wrapped Flower': {
      Mouth: 'Normal',
      Whiskers: 'Normal',
    },
    'Carved Pumpkin': {
      Eyes: 'Normal',
      Whiskers: 'Normal',
    },
    'Christmas Tree': {
      Whiskers: 'Normal',
    },
    'String Lights': {
      Whiskers: 'Normal',
      Eyes: 'Normal',
    },
    'Froggy Hat': {
      Eyes: 'Normal',
      Whiskers: 'Normal',
    },
  },
  Accessory: {
    'Robot Hand': {
      Fur: 'Normal',
    },
  },
  Fur: {
    Bricks: {
      Clothing: 'None',
    },
    'Jake the Brick': {
      Clothing: 'None',
    },
  },
  Backgrounds: {},
  Eyes: {},
  Mouthes: {},
  Special: {},
  Whiskers: {},
};

const organizedTraits = {
  Fur: {
    [ShuffleTraitRarities.Common]: [
      'Normal',
      'Green',
      'Blue',
      // 'Black',
      'Orange',
      // 'White',
      'Gray',
    ],
    [ShuffleTraitRarities.Uncommon]: [],
    [ShuffleTraitRarities.Rare]: ['Cactus', 'Bricks'],
    [ShuffleTraitRarities.UltraRare]: ['Jake the Brick'],
  },
  Clothing: {
    [ShuffleTraitRarities.Common]: [
      // 'Track Suit - 230',
      // 'Track Suit - 420',
      // 'Track Suit - Black',
      // 'Track Suit - Blue',
      // 'Track Suit - Red',
      'Bolt T-Shirt',
      // 'Holiday Scarf',
      // 'Shitty Up T-Shirt',
      // 'Checkered T-Shirt',
      'Carved Pumpkin T-Shirt',
      // 'Running Outfit',
      'Bat T-Shirt',
      'Pirate T-Shirt',
    ],
    // 'Mockingjay',  'Pot', 'Hawaiian Shirt',
    [ShuffleTraitRarities.Uncommon]: [
      // 'Crayon Belt',
      // 'Cow Suit',
      'Cardboard Sign',
      'Pumpkin Necklace',
      'Leaves',
    ],
    [ShuffleTraitRarities.Rare]: [
      // 'Grapes',
      // 'Leaves - Summer',
      'Leaves - Fall',
      'Snake',
      // 'String Lights',
      // 'Baja Hoodie',
      // 'Blueberry Suit',
      // 'Avocado Suit',
      // 'Watermelon Suit',
      'Trash Can',
      // 'Pie Dress - Blueberry',
      // 'Pie Dress - Cherry',
    ],
    [ShuffleTraitRarities.UltraRare]: [
      'Gum-ball Machine Suit',
      'Chest Burster'
    ],
  },
  Accessory: {
    [ShuffleTraitRarities.Common]: [
      // 'Watermelon',
      // 'Snowman',
      // 'Water Bottle',
      // 'Ramen',
      'Candy Apple',
      'Bluegill',
      'Goldfish',
      'Bottle of Poison',
      // 'Red Balloon',
    ],
    [ShuffleTraitRarities.Uncommon]: [
      'White Russian',
      'TV Remote',
      // 'Glow Stick',
    ],
    [ShuffleTraitRarities.Rare]: [
      'Flashlight',
      'Clownfish',
      'Brain in a Jar',
      // 'Stained Glass Umbrella'
    ],
    [ShuffleTraitRarities.UltraRare]: [
      // 'Robot Hand',
      'Slime Eye',
    ],
  },
  Head: {
    //   'Mouse Ears - Gray', 'Mouse Ears - Black', 'Flower',
    [ShuffleTraitRarities.Common]: [
      // 'Messy Purple Wig',
      // 'Braided Hair',
      // 'Cups',
      'Tin Foil Hat',
      // 'Wrapped Flower',
      // 'Dazed',
      'Melting Candle',
      'Carved Pumpkin',
    ],
    // 'Blueberry Beret'
    [ShuffleTraitRarities.Uncommon]: [
      // 'Golden Medallion',
      // 'Leaf Hat',
      'Pumpkin Hat',
      'Vines',
      // 'Christmas Tree',
      // 'Wreath',
    ],
    // 'Cyborg'
    [ShuffleTraitRarities.Rare]: [
      // 'Trash Can Lid',
      // 'TV',
      // 'Fish Bowl - Normal',
      'Fish Bowl - Skeleton',
      // 'String Lights',
      'Bats',
      'Ghosties',
      'Haunted House',
      'Worms',
    ],
    [ShuffleTraitRarities.UltraRare]: [
      'Froggy Hat',
      // 'Shark Hat',
      'Slime Eye'
    ],
  },
  Backgrounds: {
    // 'Red',
    [ShuffleTraitRarities.Common]: ['Violet', 'Orange'],
    // 'Blue'
    [ShuffleTraitRarities.Uncommon]: ['Yellow'],
    //  'Gradient 3',  'Gradient 2'
    [ShuffleTraitRarities.Rare]: ['Gradient 1'],
    [ShuffleTraitRarities.UltraRare]: [
      // 'Clouds'
    ],
  },
  Eyes: {},
  Mouthes: {
    [ShuffleTraitRarities.Common]: ['Happy'],
    [ShuffleTraitRarities.Uncommon]: [
      'Bloody Fangs',
      // 'Candy Corn Fangs'
    ],
  },
};

const formatTrait = (trait, rarity) => ({
  name: trait,
  rarity,
});

export const shuffleTraits = {
  Fur: Object.entries(organizedTraits.Fur).flatMap(([rarity, traits]) => traits.map((trait) => formatTrait(trait, rarity))),
  Clothing: Object.entries(organizedTraits.Clothing).flatMap(([rarity, traits]) => traits.map((trait) => formatTrait(trait, rarity))),
  Accessory: Object.entries(organizedTraits.Accessory).flatMap(([rarity, traits]) => traits.map((trait) => formatTrait(trait, rarity))),
  Head: Object.entries(organizedTraits.Head).flatMap(([rarity, traits]) => traits.map((trait) => formatTrait(trait, rarity))),
  Background: Object.entries(organizedTraits.Backgrounds).flatMap(([rarity, traits]) => traits.map((trait) => formatTrait(trait, rarity))),
  Mouth: Object.entries(organizedTraits.Mouthes).flatMap(([rarity, traits]) => traits.map((trait) => formatTrait(trait, rarity))),
};

export const resolveTraitDependencies = (selectedTraits) => {
  const resolvedTraits = { ...selectedTraits };

  Object.entries(selectedTraits).forEach(([category, traitName]) => {
    if (traitName && shuffleTraitDependencies[category]?.[traitName]) {
      const dependencies = shuffleTraitDependencies[category][traitName];

      Object.entries(dependencies).forEach(([depCategory, depTraitName]) => {
        resolvedTraits[depCategory] = depTraitName;
      });
    }
  });

  return resolvedTraits;
};

export const getTraitDependencies = (category, traitName) => {
  return shuffleTraitDependencies[category]?.[traitName] || {};
};
